//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').directive('datatableEmpty', () => ({
    restrict: 'E',
    scope: {},
    require: '^datatable',
    compile(element) {
      const wrapper = angular.element('<div></div>').addClass('col-xs-12 datatable-empty-state');

      wrapper.append(element.html());

      return {
        pre: null,
        post(scope, elem, attrs, datatable) {
          datatable.registerView('empty', wrapper);
        },
      };
    },
  }));
})();
